import { Flex } from '@byecode/ui'
import { useAtomData } from '@lighthouse/shared'
import { useCallback } from 'react'

import { applicationSettingAtom } from '@/atoms/application/state'

import { CoreIndicators } from '../AnalyzeTraffic/CoreIndicators'
import { NotAllow } from '../components/NotAllow'
import type { ConditionType } from '../constants'
import { CONDITION_OPTIONS, CONDITION_TYPE } from '../constants'
import { PageVisits } from './PageVisits'

const DEFAULT_CHECKED = new Set<ConditionType>([
    CONDITION_TYPE.pv,
    CONDITION_TYPE.uv,
    CONDITION_TYPE.bounceRate,
    CONDITION_TYPE.avgDepth,
    CONDITION_TYPE.avgDuration
])

export const AnalyzePage = () => {
    const isUsedCustomDomain = useAtomData(
        applicationSettingAtom,
        useCallback(s => !!s?.domain.isUsedCustomDomain && !!s?.domain.customDomain, [])
    )

    if (isUsedCustomDomain) {
        return <NotAllow />
    }

    return (
        <Flex direction="column" gap="20px">
            <CoreIndicators defaultChecked={CONDITION_OPTIONS.filter(item => DEFAULT_CHECKED.has(item.value)).map(item => item.value)} />
            <PageVisits />
        </Flex>
    )
}
